import { applicationSidebarSyncSlice } from './update';
import { combineReducers } from 'redux';

export const applicationSidebarReducers = combineReducers({
	read: applicationSidebarSyncSlice.syncReducer
});
